import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import Button from "@mui/material/Button";

import ConfiguredForm from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/ConfiguredForm";
import FormRowState from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/FormRowState";
import FormConfig from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/FormConfig";
import FormInputRowIsValid from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/FormInputRowIsValid";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";

import GetCSRFToken from "../AuthComponents/GetCSRFToken";
import { Stack } from "@mui/material";
import FormIsValid from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/FormIsValid";

function FormTestPanel() {
  const [formConfig, setFormConfig] = useState<FormConfig | undefined>(undefined);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [formState, setFormState] = useState<FormRowState[]>([]);

  useEffect(() => {
    axios
      .get("/api/test/form")
      .then((response) => {
        const formConfigLocal = { ...response.data, rowStates: undefined };
        setFormConfig(formConfigLocal);
        setFormState(response.data["rowStates"]);
      })
      .catch((error) => {
        if (process.env.NODE_ENV === "development") {
          console.log(error);
        }
      });
  }, []);

  const disableSubmit = !FormIsValid(formState, formConfig);

  // !formState.every((rowState, index) =>
  //   formConfig === undefined ? false : FormInputRowIsValid(rowState, formConfig.formConfig[index])
  // );

  function handleSubmit() {
    axios
      .post(
        "/api/test/form",
        { params: formState },
        {
          headers: { "X-CSRFToken": GetCSRFToken() },
        }
      )
      .then((res) => {
        setFormState(formState);
      })
      .catch((error) => {
        if (process.env.NODE_ENV === "development") {
          console.log(error.response);
        }
      });
  }
  return (
    <Stack>
      <ConfiguredForm
        config={formConfig}
        disabled={false}
        refreshing={refresh}
        setRefreshing={setRefresh}
        state={formState}
        setState={setFormState}
        canSubmit={!disableSubmit}
        handleSubmit={handleSubmit}
      />
      <LoadingButton variant="contained" disabled={disableSubmit} startIcon={<SaveIcon />} onClick={handleSubmit}>
        Save
      </LoadingButton>
    </Stack>
  );
}

export default FormTestPanel;
